"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Timer_1 = __importDefault(require("@seaweb/coral/utils/Timer"));
function usePoppingQueue() {
    var lastKeyRef = react_1.useRef(0);
    var scheduleMap = react_1.useRef({});
    var _a = __read(react_1.useState([]), 2), queue = _a[0], setQueue = _a[1];
    var pop = react_1.useCallback(function (key) {
        setQueue(function (q) { return q.filter(function (i) { return i.key !== key; }); });
        delete scheduleMap.current[key];
    }, []);
    var pause = react_1.useCallback(function (key) { return scheduleMap.current[key] && scheduleMap.current[key].pause(); }, []);
    var resume = react_1.useCallback(function (key) { return scheduleMap.current[key] && scheduleMap.current[key].resume(); }, []);
    var stop = react_1.useCallback(function (key) { return scheduleMap.current[key] && scheduleMap.current[key].stop(); }, []);
    var schedule = react_1.useCallback(function (key, duration) {
        stop(key);
        if (duration !== null) {
            scheduleMap.current[key] = new Timer_1.default(function () { return pop(key); }, duration);
        }
    }, [pop, stop]);
    var push = react_1.useCallback(function (data, duration) {
        if (duration === void 0) { duration = null; }
        var key = lastKeyRef.current;
        lastKeyRef.current += 1;
        setQueue(function (q) { return __spread(q, [{ data: data, key: key }]); });
        schedule(key, duration);
        return key;
    }, [schedule]);
    return {
        queue: queue,
        pop: pop,
        schedule: schedule,
        push: push,
        pause: pause,
        resume: resume,
        stop: stop,
    };
}
exports.default = usePoppingQueue;
